import nailIcon from './icons/nail.svg';
import skinIcon from './icons/skin.svg';
import diabetesIcon from './icons/diabetes.svg';
import accessibilityIcon from './icons/accessibility.svg';
import biomedicalIcon from './icons/biomedical.svg';
import shoeIcon from './icons/shoe.svg';

// 一级类目和每个类目下的内容，严格按 内容参考02.docx 的章节结构还原：
// Foot Skin Conditions / Foot nail conditions / common foot pain / Good Fitting Footwear Advice
const sections = [
    {
        id: "skin-conditions",
        tabLabel: "Foot Skin Conditions",
        title: "Foot Skin Conditions",
        icon: skinIcon,
        items: [
            {
                name: "Corn",
                description:
                    "A localised, deep and often painful area of thickened skin over a bony area, usually caused by repeated pressure or friction from tight or ill-fitting shoes, bony deformities such as hammertoes or bunions, high heels, or an abnormal gait.",
            },
            {
                name: "Callus (Hard Skin)",
                description:
                    "An area of skin that has become thick and hard from chronic friction and pressure — larger and more diffuse than a corn — often from long periods standing or walking, barefoot walking, poor footwear, or repetitive sport or work activities.",
            },
            {
                name: "Plantar Warts",
                subtitle: "Verruca",
                description:
                    "A viral skin infection (HPV) that enters through tiny cuts in the skin and can occur on the sole of the foot, often picked up barefoot in moist shared spaces like pools and locker rooms.",
            },
            {
                name: "Fungal Skin Infection",
                subtitle: "Tinea",
                description:
                    "A fungal skin infection often picked up in moist shared spaces such as pools, locker rooms and shower rooms, causing peeling or broken skin, sometimes with redness, between the toes.",
            },
                  {
                name: "Cracked Heel",
                subtitle: "Heel Fissure",
                description:
                    "Thickened, dry heel skin that cracks under pressure, often made worse by prolonged standing, obesity, open-back footwear, or skin conditions such as eczema. Can lead to infection if left untreated.",
            },
            {
                name: "Paronychia",
                description:
                    "Inflammation of the skin around a toenail, which can be acute or chronic. Often caused by an ingrown toenail, nail biting or picking, or infection, with redness, swelling and sometimes discharge.",
            },
        ],
    },
    {
        id: "nail-conditions",
        tabLabel: "Foot Nail Conditions",
        title: "Foot Nail Conditions",
        icon: nailIcon,
        items: [
            {
                name: "Ingrown Toenail",
                subtitle: "Onychocryptosis",
                description:
                    "The side or corner of the toenail digs into the surrounding skin, causing pain and redness. It usually affects the big toe but can happen on other toes too, and is a common problem for teenagers, young adults, and people who are overweight or have flat feet or high-arched feet.",
            },
            {
                name: "Fungal Nail",
                description:
                    "Toenails become thicker and change colour (yellow, white, blue, purple or black), with or without pain. It becomes more common as you get older, and can spread from athlete's foot, shared nail clippers or towels, or bare feet in shared showers and pools.",
            },
        ],
    },
    {
        id: "diabetic-foot",
        tabLabel: ["Diabetic Foot Assessment and", "Treatment"],
        title: "Diabetic Foot Assessment and Treatment",
        icon: diabetesIcon,
        items: [],
    },
    {
        id: "foot-pain",
        tabLabel: "Common Foot Pain",
        title: "Common Foot Pain",
        icon: accessibilityIcon,
        items: [
            {
                name: "Morton's Neuroma",
                subtitle: "Forefoot Pain",
                description:
                    "A damaged, enlarged nerve causing sharp, burning pain in the ball of the foot, sometimes like walking on a pebble, with tingling or numbness in the toes — most commonly the 3rd and 4th.",
            },
            {
                name: "Plantar Fasciitis",
                subtitle: "Rearfoot Pain",
                description:
                    "Sharp, stabbing heel pain typically felt with your first steps in the morning, caused by repetitive stress or overuse of the plantar ligament, barefoot walking or standing for long periods, inadequate footwear, and tight calf muscles.",
            },
        ],
    },
    {
        id: "biomedical-assessment",
        tabLabel: ["Biomedical Assessment and", "Treatment for Foot Condition"],
        title: "Biomedical Assessment and Treatment for Foot Condition",
        icon: biomedicalIcon,
        items: [],
    },
    {
        id: "footwear-advice",
        tabLabel: ["Good Fitting", "Footwear Advice"],
        title: "Good Fitting Footwear Advice",
        icon: shoeIcon,
        items: [
            {
                name: "Footwear Advice",
                description:
                    "Choosing the right footwear is an important part of maintaining foot health. For some patients, can help improve foot pressure distribution and enhance comfort.",
            },
        ],
    },
];

export default sections;
